(() => {
  function enhance(scope = document) {
    scope.querySelectorAll('[data-sbg-summary]:not([data-ready])').forEach(el => {
      const source = el.querySelector('template');
      if (!source) return;
      const raw = source.content.textContent;
      const paragraphs = [...source.content.querySelectorAll('p')];
      const intro = (paragraphs[0]?.textContent || raw).trim();
      const sentence = intro.match(/^.*?[.!?](?:\s|$)/)?.[0]?.trim() || intro;
      el.querySelector('[data-intro]').textContent = sentence.length > 240 ? sentence.slice(0, 237).replace(/\s+\S*$/, '') + '…' : sentence;
      const facts = el.querySelector('[data-facts]');
      const add = (label, value) => {
        if (!value || [...facts.querySelectorAll('dt')].some(d => d.textContent === label)) return;
        const row = document.createElement('div');
        const dt = document.createElement('dt'); dt.textContent = label;
        const dd = document.createElement('dd'); dd.textContent = value;
        row.append(dt, dd); facts.append(row);
      };
      const scratch = source.content.cloneNode(true);
      scratch.querySelectorAll('br').forEach(br => br.replaceWith('\n'));
      const lines = scratch.textContent.split('\n').map(x => x.trim()).filter(Boolean);
      if (el.dataset.defaultVariant === 'true') {
        for (const [label, pattern] of [['Dimensions', /^(?:Size|Dimensions|Size dimensions)\s*:\s*(.+)$/i], ['Weight', /^Weight\s*:\s*(.+)$/i]]) {
          const line = lines.find(x => pattern.test(x));
          if (line) add(label, line.match(pattern)[1]);
        }
      }
      if (/sterling silver/i.test(raw)) add('Metal', 'Sterling silver');
      const origin = intro.match(/\bfrom\s+(Peru|Oregon|Turkey|Madagascar|Brazil|the Congo|Congo)\b/i);
      if (origin) add('Origin', origin[1]);
      facts.hidden = !facts.children.length;
      const selection = el.querySelector('[data-selection]');
      selection.hidden = false;
      if (/intuitiv/i.test(raw)) selection.textContent = 'Intuitive selection — photographs show examples; your piece may vary.';
      else if (el.dataset.defaultVariant !== 'true') selection.textContent = 'Choose your numbered style — you will receive the piece matching your selection.';
      else if (/exact|crystal photographed/i.test(raw)) selection.textContent = 'You will receive the exact piece pictured.';
      else selection.hidden = true;
      el.dataset.ready = 'true';
    });
    scope.querySelectorAll('[data-sbg-details]:not([data-ready])').forEach(el => {
      const source = el.querySelector('template'); if (!source) return;
      const groups = {about: [], pieces: [], traditions: [], care: []};
      [...source.content.children].forEach((p, index) => {
        const text = p.textContent.trim();
        if (!text || /^follow us|^thank you|^\*?intuitive|^you pick|^item pictured/i.test(text)) {
          if (/size|weight|grams|\d+\./i.test(text)) groups.pieces.push(p.cloneNode(true));
          return;
        }
        if (/model,?\s*Kasia|combine shipping|shipping overages|screen|monitor|packaged with love/i.test(text)) return;
        let key = /metaphysical|healing|spirit|chakra|manifest|angel|celestial|energy|tranquili|anxiety|wealth|masculine|abundance|soul path|higher realms/i.test(text) ? 'traditions' : /handle.*care|cleaning|fragile|avoid.*water/i.test(text) ? 'care' : /size\s*:|dimensions|weight\s*:|grams|\d+\s*\./i.test(text) ? 'pieces' : 'about';
        groups[key].push(p.cloneNode(true));
      });
      for (const [key, nodes] of Object.entries(groups)) {
        const section = el.querySelector('[data-group="' + key + '"]');
        if (!nodes.length) { section.remove(); continue; }
        section.querySelector('[data-content]').append(...nodes);
      }
      el.dataset.ready = 'true';
    });
    scope.querySelectorAll('[data-sbg-product-title]').forEach(el => {
      const full = el.dataset.sbgProductTitle;
      const title = full.split(/\s*-\s*you pick|,?\s*you pick!?|\s*-\s*genuine crystal|,?\s*reiki energy|\s*-\s*reiki|,?\s*healing crystals|,?\s*metaphysical|,\s*Natural Crystals|,\s*Ascension Crystal|\s*-\s*One of a kind carvings/i)[0].replace(/[\s,\-]+$/, '');
      if (title) el.textContent = title;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
